<div class="container" *ngIf="finishedLoading">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Partner bearbeiten</mat-card-title>
                    <mat-card-subtitle>{{this.addForm.value.name}}</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content [formGroup]="addForm">
                    <div class="add-lessons-form">
                        <div class="row" *ngIf="!this.addForm.value?.image.url">
                            <div class="col-sm-12">
                                <div ngx-dropzone [multiple]="false" [accept]="'image/jpeg,image/jpg,image/png'"
                                    (change)="onSelect($event)" *ngIf="!hasLogo">
                                    <ngx-dropzone-label>
                                        <div>
                                            <h3>Bild hierher ziehen</h3>
                                            <h5>ODER</h5>
                                            <button mat-raised-button color="accent">Durchsuchen</button>
                                        </div>
                                    </ngx-dropzone-label>
                                    <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview"
                                        *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onRemove(f)">
                                        <!-- <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label> -->
                                    </ngx-dropzone-image-preview>
                                </div>
                                <mat-error *ngIf="addForm.get('image').hasError('required')">
                                    Logo <strong>muss</strong> hochgeladen werden
                                </mat-error>
                            </div>
                        </div>

                        <div class="row ">
                            <div class="col-sm-12">
                                <div class="centerVerticalAndHoritontal">
                                    <img class="img-responsive  img-clickable" style="max-height: 150px; margin: 2rem;"
                                        src="{{this.addForm.value?.image.href}}" alt="">
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="centerVerticalAndHoritontal marginBottom2Rem">
                                    <button mat-raised-button color="primary" (click)="toggleLogoUpload()">Logo
                                        hochladen</button>

                                </div>

                            </div>
                        </div>

                        <div class="row ">
                            <div class="col-sm-12">
                                <mat-form-field class="full-width">
                                    <mat-label>Rolle:</mat-label>
                                    <mat-select formControlName="businessRole">
                                        <mat-option *ngFor="let sortOption of sortOptions" [value]="sortOption.value">
                                            {{sortOption.viewValue}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error>
                                        Rolle <strong>muss</strong> angegeben werden
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12">
                                <mat-form-field class="full-width">
                                    <mat-label>Firmenname:</mat-label>
                                    <input matInput formControlName="name">
                                    <mat-error *ngIf="addForm.get('name').hasError('required')">
                                        Firmenname <strong>muss</strong> angegeben werden
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div formGroupName="address">
                            <div class="row">
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Straße und Hausnummer:</mat-label>
                                        <input matInput formControlName="street">
                                        <mat-error *ngIf="addForm.get('address').get('street').hasError('required')">
                                            Hausnummer <strong>muss</strong> angegeben werden
                                        </mat-error>
                                        <mat-error *ngIf="addForm.get('address').get('street').hasError('pattern')">
                                            Straße und Hausnummer <strong>muss</strong> im Format Straße
                                            Hausnummer
                                            angegeben
                                            werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                            </div>
                            <div class="row ">
                                <div class="col-sm-4">
                                    <mat-form-field class="full-width">
                                        <mat-label>PLZ:</mat-label>
                                        <input matInput formControlName="postcode">
                                        <mat-error *ngIf="addForm.get('address').get('postcode').hasError('required')">
                                            PLZ <strong>muss</strong> angegeben werden
                                        </mat-error>

                                        <mat-error *ngIf="addForm.get('address').get('postcode').hasError('required')">
                                            PLZ <strong>muss</strong> aus 5 Zahlen bestehen
                                        </mat-error>

                                        <mat-error *ngIf="addForm.get('address').get('postcode').hasError('minlength')">
                                            PLZ <strong>muss</strong> aus 5 Zahlen bestehen
                                        </mat-error>

                                        <mat-error *ngIf="addForm.get('address').get('postcode').hasError('maxlength')">
                                            PLZ <strong>muss</strong> aus 5 Zahlen bestehen
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-8">
                                    <mat-form-field class="full-width">
                                        <mat-label>Ort:</mat-label>
                                        <input matInput formControlName="city">
                                        <mat-error *ngIf="addForm.get('address').get('postcode').hasError('required')">
                                            Hausnummer <strong>muss</strong> angegeben werden
                                        </mat-error>


                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row marginBottom2Rem" formGroupName="location">
                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Breitengrad:</mat-label>
                                        <input matInput formControlName="lat">
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Längengrad:</mat-label>
                                        <input matInput formControlName="lng">
                                    </mat-form-field>
                                </div>
                            </div>

                            



                            <div class="row marginBottom2Rem">
                                <div class="col-sm-4">
              
                                    <mat-spinner [diameter]="21" *ngIf="loadingLocation"></mat-spinner>
                            
                                    <div *ngIf="!loadingLocation">
                                        <button mat-raised-button class="full-width" color="accent"
                                        (click)="getPositions()">
                                        Koordinaten ermitteln
                         
                                    </button>
                                    </div>

          
                                </div>
                                <div class="col-sm-8" *ngIf="loadedLocation">
                                    <h5>Koordinaten erfolgreich ermittelt!</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="edit()" class="oneStepForwardBtn"
                        >Änderungen
                        speichern</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
    <div class="row marginTop2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Öffnungszeiten bearbeiten</mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="openingHoursForm">
                    <div class="add-lessons-form">
                        <ng-container class="full-width">
                            <ng-container *ngFor="let lessonForm of openingHours.controls; let i = index">
                                <div class="row flex" [formGroup]="lessonForm">
                                    <div class="col-sm-11">
                                        <mat-form-field class="full-width">
                                            <mat-label>Öffnungszeit:</mat-label>
                                            <input matInput formControlName="name">
                                            <mat-error *ngIf="lessonForm.get('name').hasError('required')">
                                                Öffnungszeit <strong>muss</strong> angegeben werden
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-1">
                                        <button mat-icon-button style="margin: 0 auto !important;margin-top: 0.5rem;"
                                            [matMenuTriggerFor]="menu" color="accent">
                                            <mat-icon>more_vert</mat-icon>
                                        </button>
                                        <mat-menu #menu="matMenu">
                                            <button mat-menu-item (click)="deleteOpeningHours(i)">
                                                <span>Löschen</span>
                                            </button>
                                        </mat-menu>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>

                    </div>

                    <div>
                        <div class="marginTop2Rem"></div>
                        <button mat-raised-button color="accent" style="margin-top: 0.5rem;"
                            (click)="addOpeningHours()">
                            Hinzufügen <mat-icon class="add-course-btn">add</mat-icon>
                        </button>
                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="edit()" class="oneStepForwardBtn"
                        >Änderungen
                        speichern</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
    <div class="row marginTop2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Kontaktdaten bearbeiten</mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="contactChannelsForm">
                    <div class="add-lessons-form">
                        <ng-container class="full-width">
                            <ng-container *ngFor="let lessonForm of contactChannels.controls; let i = index">
                                <div class="row flex" [formGroup]="lessonForm">
                                    <div class="col-sm-3">
                                        <mat-form-field class="full-width">
                                            <mat-label>Typ:</mat-label>
                                            <mat-select formControlName="channelType"
                                                (selectionChange)="changeAvalibleContactChannels($event)">
                                                <mat-option
                                                    *ngFor="let sortOption of contactChannelOptions;let i = index"
                                                    (change)="disableType()" [value]="sortOption.value"
                                                    [disabled]="sortOption.state">
                                                    {{sortOption.viewValue}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error>
                                                Typ <strong>muss</strong> angegeben werden
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-8">
                                        <mat-form-field class="full-width">
                                            <mat-label>Adresse:</mat-label>
                                            <input matInput formControlName="channelData">

                                            <mat-error *ngIf="lessonForm.get('channelData').hasError('required')">
                                                Adresse <strong>muss</strong> angegeben werden
                                            </mat-error>
                                        </mat-form-field>

                                    </div>

                                    <div class="col-sm-1">
                                        <button mat-icon-button style="margin: 0 auto !important;"
                                            [matMenuTriggerFor]="menu" color="accent">
                                            <mat-icon>more_vert</mat-icon>
                                        </button>
                                        <mat-menu #menu="matMenu">
                                            <button mat-menu-item (click)="deletContactChannels(i)">
                                                <span>Löschen</span>
                                            </button>
                                        </mat-menu>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                    <div>
                        <div class="marginTop2Rem"></div>
                        <button mat-raised-button color="accent" style="margin-top: 0.5rem;"
                            (click)="addContactChannels()">
                            Hinzufügen <mat-icon class="add-course-btn">add</mat-icon>
                        </button>
                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="edit()" class="oneStepForwardBtn"
                        >Änderungen
                        speichern</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>

    <div class="row marginTop2Rem">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title>Benutzerkonten bearbeiten</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="row" class="rowFlex" *ngFor="let member of this.membersToBusinessEntity">
                        <div class="col-sm-12">
                            <mat-list>
                                <mat-list-item>
                                    <a [routerLink]="['edit',member.publicId]" routerDirection="root"
                                        style="text-decoration: underline;">
                                        <span>
                                            {{member?.person?.displayName}}
                                        </span>
                                    </a>

                                </mat-list-item>
                            </mat-list>
                        </div>
                    </div>
                    <div>
                        <div class="marginTop2Rem"></div>
                        <button mat-raised-button color="accent" [routerLink]="['add']">
                            Hinzufügen <mat-icon class="add-course-btn">add</mat-icon>
                        </button>
                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="edit()" class="oneStepForwardBtn"
                        >Änderungen
                        speichern</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
</div>
<div class="container" *ngIf="!finishedLoading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>